// @flow
import { type GlobalStateType, type StateType } from 'Lib/reduxType';

export function objectShouldPersist(prevState: ?StateType, nextState: StateType) {
  return prevState ? prevState !== nextState : !!nextState;
}

export default function shouldPersist(prevState: GlobalStateType, nextState: GlobalStateType) {
  return objectShouldPersist(prevState, nextState);
}
